'use strict';
define([], function () {
    return function () {
        return [
            {
                name: 'settings.account',
                icon: 'account_circle',
                isOpened: false,
                mobileTabOrder: 1,
                submenu: [
                    {
                        name: 'settings.profile',
                        navIcon: 'ti ti-user-circle',
                        isOpened: false,
                        mobileTabOrder: 2,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.update'],
                        },
                    },
                    {
                        name: 'settings.change.password',
                        navIcon: 'ti ti-lock',
                        isOpened: false,
                        mobileTabOrder: 3,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.changePassword'],
                        },
                    },
                    {
                        name: 'settings.invitations',
                        navIcon: 'ti ti-mail',
                        isOpened: false,
                        mobileTabOrder: 6,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.invitations'],
                        },
                    }
                ]
            },
            {
                name: 'Workspace',
                icon: 'workspaces_outline',
                isOpened: false,
                mobileTabOrder: 8,
                permission: [
                    'workspace_user_admin',
                    'workspace_user_manager',
                    'workspace_user_bookkeeper',
                    'workspace_user_marketer',
                    'workspace_user_client'
                ],
                submenu: [
                    {
                        name: 'settings.customizations',
                        navIcon: 'ti ti-palette',
                        isOpened: false,
                        mobileTabOrder: 9,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.customizations'],
                        },
                        permission: 'workspace_edit',
                    },
                    {
                        name: 'settings.partner.area',
                        navIcon: 'ti ti-affiliate',
                        isOpened: false,
                        mobileTabOrder: 10,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.partnersArea'],
                        },
                        permission: 'workspace_partner_program_read'
                    },
                    {
                        name: 'users',
                        navIcon: 'ti ti-users',
                        isOpened: false,
                        mobileTabOrder: 11,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.users'],
                        },
                        permission: [
                            'workspace_user_admin',
                            'workspace_user_manager',
                            'workspace_user_bookkeeper',
                            'workspace_user_marketer',
                            'workspace_user_client'
                        ]
                    },
                    {
                        name: 'settings.logs',
                        navIcon: 'ti ti-history',
                        isOpened: false,
                        mobileTabOrder: 12,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.logs'],
                        },
                        permission: 'workspace_log_read'
                    }
                ]
            },
            {
                name: 'settings.plans.and.subscriptions',
                icon: 'check_circle_outline',
                isOpened: false,
                mobileTabOrder: 13,
                submenu: [
                    {
                        name: 'settings.overview.credits-limits',
                        navIcon: 'ti ti-chart-pie',
                        isOpened: false,
                        mobileTabOrder: 14,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.overview'],
                        },
                    },
                    {
                        name: 'settings.subscriptions',
                        navIcon: 'ti ti-calendar-dollar',
                        isOpened: false,
                        mobileTabOrder: 15,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.subscriptions'],
                        },
                        permission: 'workspace_subscriptions_read'
                    },
                    {
                        name: 'settings.invoices',
                        navIcon: 'ti ti-receipt',
                        isOpened: false,
                        mobileTabOrder: 16,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.invoices'],
                        },
                        permission: 'workspace_invoice_read'
                    },
                    {
                        name: 'settings.billing.info',
                        navIcon: 'ti ti-file-invoice',
                        isOpened: false,
                        mobileTabOrder: 17,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.billingInfo'],
                        },
                        permission: 'workspace_payment_methods_read'
                    },
                    {
                        name: 'settings.payment.methods',
                        navIcon: 'ti ti-credit-card',
                        isOpened: false,
                        mobileTabOrder: 18,
                        link: {
                            type: 'internal',
                            urls: ['app.settings.paymentsMethods'],
                        },
                        permission: 'workspace_payment_methods_read'
                    }
                ]
            },
            {
                name: 'API',
                navIcon: 'ti ti-api',
                icon: 'api',
                isOpened: false,
                mobileTabOrder: 19,
                link: {
                    type: 'internal',
                    urls: ['app.settings.api'],
                },
            },
        ];
    };
});
